$(document).ready( function() {
    if($('body.single-product').length > 0) {

        if( $('.description-video').length > 0) {
            $('.variations select').on('change', updateVideo);
            updateVideo();
        }
    }
})

// This function updates which video is shown based on current select values.
function updateVideo() {

    $('.single-product .description-video').hide();

    var selectedValues = {};
    var notSelectedValues = {};

    $('.variations select').each(function() {
        var variationName = $(this).attr('id');
        var selectedValue = $(this).val();

        if( selectedValue ) {
            selectedValues[variationName] = {
                value: selectedValue,
                video: false
            };
        } else {
            notSelectedValues[variationName] = {
                video: false
            }
        }
    });

    $('.single-product .description-video').each(function() {
        var showVideo = true;
        const $img = $(this);

        //check if Video has value for selected value and hide ones that have different values
        Object.keys(selectedValues).forEach(function(key) {
            var object = selectedValues[key];
            if($img.is('[data-' + key + ']')) {
                if ($img.attr('data-' + key) !== object.value) {
                    showVideo = false;
                    return false;
                }
            }
        })

        if(showVideo == true) {
            //show first value for not selected values
            if(Object.keys(notSelectedValues).length > 0) {
                Object.keys(notSelectedValues).forEach(function(key) {
                    var object = notSelectedValues[key];
                    if (object.video === false && $img.is('[data-' + key + ']')) {
                        $img.show();
                        notSelectedValues[key].Video = true;
                    }
                });   
            }

            //show selected Video
            if(Object.keys(selectedValues).length > 0) {
                Object.keys(selectedValues).forEach(function(key) {
                    var object = selectedValues[key];
                    if (/*object.video === false &&*/ $img.is('[data-' + key + ']')) {
                        if ($img.attr('data-' + key) == object.value) {
                            $img.show();
                            selectedValues[key].Video = true;
                        }
                    }
                });   
            }
        }
    });
}
